import { useEffect, useState } from 'react';
import { useSettings } from '@wu/widget-core';
import type { MenuItem as MenuItemType } from '../../../../../types';
import { DataProvider } from './DataProvider';
import { MenuItem } from './MenuItem';
import { TabsControl } from './tabs-control';

export function Tabs() {
  const { menus = [] } = useSettings();
  const [selectedMenu, setSelectedMenu] = useState<MenuItemType | undefined>(
    undefined
  );
  const [selectedMenuId, setSelectedMenuId] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    setSelectedMenu(
      menus.find((item) => item.id === selectedMenuId) ?? menus[0]
    );
  }, [menus]);

  useEffect(() => {
    setSelectedMenuId(selectedMenu?.id);
  }, [selectedMenu]);

  if (
    menus.length === 0 ||
    !selectedMenu ||
    Object.keys(selectedMenu).length === 0
  ) {
    return null;
  }

  return (
    <>
      <TabsControl
        selectedMenu={selectedMenu}
        setSelectedMenu={setSelectedMenu}
      />

      <DataProvider data={selectedMenu}>
        <MenuItem />
      </DataProvider>
    </>
  );
}
